import { useMutation, useQueryClient } from 'react-query';
import {
  updateCastRelationship,
  type UpdateCastRelationshipBody,
  type UpdateCastRelationshipResponse
} from '../../services/castRelationshipService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useUpdateCastRelationship() {
  const queryClient = useQueryClient();
  return useMutation<
    UpdateCastRelationshipResponse,
    Error,
    { castRelationshipId: string; body: UpdateCastRelationshipBody }
  >({
    mutationFn: ({ castRelationshipId, body }) =>
      updateCastRelationship({ castRelationshipId, body }),
    onSuccess: () => {
      queryClient.invalidateQueries(SCENE_QUERY_KEYS.castRelationships());
      queryClient.invalidateQueries(SCENE_QUERY_KEYS.castRelationship());
      queryClient.invalidateQueries(SCENE_QUERY_KEYS.adaptedFictionPreviews);
    }
  });
}
